/** @format */

import type { PaperCover } from "@question-bank/shared";

const configurePdfWorker = async (): Promise<void> => {
	if (typeof window === "undefined") {
		return;
	}
	const { GlobalWorkerOptions } = await import("pdfjs-dist/legacy/build/pdf.mjs");
	if (!GlobalWorkerOptions.workerSrc) {
		GlobalWorkerOptions.workerSrc = new URL("pdfjs-dist/legacy/build/pdf.worker.min.mjs", import.meta.url).href;
	}
};

/** Read the text of page 1. Returns null when the file has no usable text layer. */
export const readFirstPageText = async (file: File): Promise<string | null> => {
	try {
		const { readPdfPages } = await import("@question-bank/shared/pdf");
		await configurePdfWorker();
		const pages = await readPdfPages(new Uint8Array(await file.arrayBuffer()), 1);
		const text = (pages[0]?.items ?? [])
			.map((item) => item.text)
			.join(" ")
			.replace(/\s+/g, " ")
			.trim();
		return text.length > 0 ? text : null;
	} catch {
		return null;
	}
};

/** Read the exam-paper cover. Returns null when the file has no usable text layer. */
export const readPaperCover = async (file: File): Promise<PaperCover | null> => {
	try {
		const [{ readPdfPages }, { extractQuestionPaper }] = await Promise.all([
			import("@question-bank/shared/pdf"),
			import("@question-bank/shared"),
		]);
		await configurePdfWorker();
		const pages = await readPdfPages(new Uint8Array(await file.arrayBuffer()), 1);
		const cover = extractQuestionPaper(pages).cover;
		const hasFact = Boolean(cover.paperCode || cover.subject || cover.level || cover.tier || cover.date);
		return hasFact ? cover : null;
	} catch {
		return null;
	}
};
